export { useAutoLikePost } from './useAutoLikePost';
